import { render, staticRenderFns } from "./AssetContext.vue?vue&type=template&id=9db475d2&scoped=true&"
import script from "./AssetContext.vue?vue&type=script&lang=js&"
export * from "./AssetContext.vue?vue&type=script&lang=js&"
import style0 from "./AssetContext.vue?vue&type=style&index=0&id=9db475d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db475d2",
  null
  
)

export default component.exports